/**
 * ReactDOM render platform
 * insert dynamic reactjs content into static html page
 */
import React from "react";
import ReactDOM from "react-dom";

/**
 * Import required elements
 */
// Store and theme app provider
import Provider from "lib/Provider"
// Platform app
import Platform from "./Platform";

import SimtopyUtils from "Utils"
import SimtopyAPI from "api"
import MimeDB from "mime-db"
import Lodash from "lodash"
import * as XLSX from 'xlsx/dist/xlsx.full.min.js';
import { set_cptable } from "xlsx"
import * as cptable from 'xlsx/dist/cpexcel.full.mjs';
set_cptable(cptable);

// import Install from "./Install";
global.SimtopyUtils = SimtopyUtils
global.SimtopyAPI = SimtopyAPI
global.MimeDB = MimeDB
global.Lodash = Lodash
global.XLSX = XLSX

// root static <div /> in index.html
ReactDOM.render(
  <Provider>
    <Platform />
  </Provider>,
  document.getElementById("root")
);